module.exports = __webpack_public_path__ + "img/en.b6463b18.png";